import { BillingStatus, InvitationStatus, OrgRole } from '../../enums';
import { RequestType } from '../invitations';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedInvitation = {
    id: 0,
    type: RequestType.orgMembershipInvitation,
    role: OrgRole.admin,
    createdAt: '0',
    acceptedAt: null,
    declinedAt: '0',
    senderOrganizationId: 0,
    senderOrganizationName: 'Sender Organization Name',
    recipientName: 'recipientName',
    recipientEmail: 'recipient@email.com',
    chargedToNetwork: false,
    recipientOrgName: 'Recipient Organization Name',
    isSentToMe: true,
    senderPhoneCountry: 'FR',
    senderPhoneNumber: '0600000000',
    senderName: 'sender',
    senderEmail: 'sender@email.com',
    acceptUrl: 'https://app-preprod.weenat.com/me/invitations/accept/eyJpbnZpdGF0aW9uIjogMTM5NSwgInR5cGUiOiAwLCAiZW1haWwiOiAicmVuYXVkLmNhZGVsQGdtYWlsLmNvbSIsICJ1c2VyIjogMH0=',
    status: InvitationStatus.pending,
    metadata: {
        billingStatus: BillingStatus.essential,
        firstName: 'firstName',
        lastName: 'lastName',
        organizationName: 'organizationName',
        phone: {
            country: 'FR',
            number: '03 12 45 69 87'
        },
        membershipCode: 'LKD54AZ'
    }
};
const mock = {
    deletion: mockedRequester(undefined, 'invitations.deletion'),
    received: {
        get: mockedRequester(mockedInvitation, 'invitations.received.get'),
        accept: mockedRequester(undefined, 'invitations.received.accept'),
        decline: mockedRequester(undefined, 'invitations.received.decline'),
        getAll: mockedRequester([mockedInvitation], 'invitations.received.getAll'),
        getMany: mockedRequester(mockedPaginatedResponse([mockedInvitation]), 'invitations.received.getMany'),
        getPage: mockedRequester(mockedPaginatedResponse([mockedInvitation]), 'invitations.received.getPage')
    },
    receivedPerNetwork: {
        get: mockedRequester(mockedInvitation, 'invitations.receivedPerNetwork.get'),
        accept: mockedRequester(undefined, 'invitations.receivedPerNetwork.accept'),
        decline: mockedRequester(undefined, 'invitations.receivedPerNetwork.decline'),
        getAll: mockedRequester([mockedInvitation], 'invitations.receivedPerNetwork.getAll'),
        getMany: mockedRequester(mockedPaginatedResponse([mockedInvitation]), 'invitations.receivedPerNetwork.getMany'),
        getPage: mockedRequester(mockedPaginatedResponse([mockedInvitation]), 'invitations.receivedPerNetwork.getPage')
    },
    sent: {
        get: mockedRequester(mockedInvitation, 'invitations.sent.get'),
        getMany: mockedRequester(mockedPaginatedResponse([mockedInvitation]), 'invitations.sent.getMany'),
        getAll: mockedRequester([mockedInvitation], 'invitations.sent.getAll'),
        getPage: mockedRequester(mockedPaginatedResponse([mockedInvitation]), 'invitations.sent.getPage'),
        download: mockedRequester({}, 'invitations.sent.download'),
        cancel: mockedRequester({}, 'invitations.sent.cancel')
    },
    invite: {
        toJoinNetwork: mockedRequester(mockedInvitation, 'invitations.invite.toJoinNetwork'),
        toJoinOrganization: mockedRequester(mockedInvitation, 'invitations.invite.toJoinNetwork')
    },
    beg: {
        networkMembership: mockedRequester(undefined, 'invitations.beg.networkMembership')
    }
};
export default mock;
